import React from "react";
import {
  Box, Button, Grid, IconButton, MenuItem, Stack, TextField, Typography,
} from "@mui/material";
import AddRounded from "@mui/icons-material/AddRounded";
import DeleteOutlineRounded from "@mui/icons-material/DeleteOutlineRounded";
import { getMessage } from "../i18n/locale";

export default function AvailabilityEditor({ value, onChange, locale, defaultTimeZone }) {
  const update = (index, key) => (event) => {
    onChange(value.map((entry, entryIndex) => (
      entryIndex === index ? { ...entry, [key]: event.target.value } : entry
    )));
  };

  const add = () => onChange([
    ...value,
    {
      startDate: "",
      endDate: "",
      timeZone: defaultTimeZone,
      state: "AVAILABLE",
      notes: "",
    },
  ]);

  return (
    <Stack spacing={2}>
      <Box>
        <Typography variant="h6">{getMessage(locale, "availabilityEditorTitle")}</Typography>
        <Typography variant="body2" color="text.secondary">
          {getMessage(locale, "availabilityEditorHint")}
        </Typography>
      </Box>
      {value.map((entry, index) => (
        <Grid container spacing={1.5} alignItems="center" key={index}>
          <Grid size={{ xs: 12, sm: 3 }}>
            <TextField
              fullWidth required type="date"
              label={getMessage(locale, "availabilityStartDate")}
              value={entry.startDate}
              onChange={update(index, "startDate")}
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 3 }}>
            <TextField
              fullWidth required type="date"
              label={getMessage(locale, "availabilityEndDate")}
              value={entry.endDate}
              onChange={update(index, "endDate")}
              slotProps={{ inputLabel: { shrink: true } }}
            />
          </Grid>
          <Grid size={{ xs: 10, sm: 2 }}>
            <TextField
              fullWidth select label={getMessage(locale, "availabilityState")}
              value={entry.state}
              onChange={update(index, "state")}
            >
              {["AVAILABLE", "TENTATIVE", "UNAVAILABLE"].map((state) => (
                <MenuItem key={state} value={state}>
                  {getMessage(locale, `availabilityState${state}`)}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid size={{ xs: 10, sm: 3 }}>
            <TextField
              fullWidth required
              label={getMessage(locale, "availabilityTimeZone")}
              value={entry.timeZone}
              onChange={update(index, "timeZone")}
              helperText={getMessage(locale, "availabilityTimeZoneHint")}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 1 }}>
            <IconButton
              color="error"
              aria-label={getMessage(locale, "availabilityRemove")}
              onClick={() => onChange(value.filter((_, entryIndex) => entryIndex !== index))}
            >
              <DeleteOutlineRounded />
            </IconButton>
          </Grid>
          <Grid size={{ xs: 12 }}>
            <TextField
              fullWidth
              label={getMessage(locale, "availabilityNotes")}
              value={entry.notes}
              onChange={update(index, "notes")}
            />
          </Grid>
        </Grid>
      ))}
      <Button variant="outlined" startIcon={<AddRounded />} onClick={add} sx={{ alignSelf: "flex-start" }}>
        {getMessage(locale, "availabilityAdd")}
      </Button>
    </Stack>
  );
}
